import { render } from "./PrayerRoomModule.vue?vue&type=template&id=3c40ed0a&scoped=true"
import script from "./PrayerRoomModule.vue?vue&type=script&lang=js"
export * from "./PrayerRoomModule.vue?vue&type=script&lang=js"

import "./PrayerRoomModule.vue?vue&type=style&index=0&id=3c40ed0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c40ed0a"

export default script